import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

/**
 * Numeric field for CO2 emission discharged value (WLTP standard).
 * Automatically calculates and fills the corresponding CO2 class field when value changes.
 * Only visible for BEL and DEU tenants.
 */
export function CarbonDioxideEmissionDischargedField() {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.CARBON_DIOXIDE_EMISSION_DISCHARGED_CHANGED,
      value: value != null ? String(value) : null,
    });
  };

  return (
    <Field
      type="number"
      name="carbonDioxideEmissionDischarged"
      label={i18n.t('entity.vehicle.labels.carbonDioxideEmissionDischarged')}
      suffix={i18n.t('general.metric.gkm')}
      decimalPlaces={2}
      onChange={handleChange}
    />
  );
}
